<div class="container-fluid col-11 px-4" *ngIf="genericCleanupView">
  <p-card>
    <form #genericCleanupForm="ngForm" id="genericCleanupForm" class="d-flex justify-content-center">
      <div class="p-fluid grid w-90">
        <div class="p-field col-4">
          <p-floatlabel>
            <p-inputNumber
              #retentionMonths="ngModel"
              name="retentionMonths"
              mode="decimal"
              [(ngModel)]="genericCleanupView.retentionMonths"
              [showButtons]="true"
              [min]="1"
              [max]="99"
              required>
            </p-inputNumber>

            <label htmlFor="retentionMonths" translate> Administration.Cleanup.Form.Retention Months </label>
          </p-floatlabel>
          <small *ngIf="retentionMonths.touched && retentionMonths.errors?.required" class="text-danger" translate>
            Administration.Cleanup.Form.Errors.Retention Months Required
          </small>
        </div>
        <div class="p-field col-3">
          <p-floatlabel>
            <p-inputNumber
              #dayOfTheMonth="ngModel"
              name="dayOfTheMonth"
              mode="decimal"
              [(ngModel)]="genericCleanupView.dayOfTheMonth"
              [showButtons]="true"
              [min]="1"
              [max]="28"
              [disabled]="genericCleanupView.dayOfTheWeek"
              [required]="!genericCleanupView.dayOfTheWeek">
            </p-inputNumber>

            <label htmlFor="dayOfTheMonth" translate> Administration.Cleanup.Form.Day Of The Month </label>
          </p-floatlabel>
          <small *ngIf="dayOfTheMonth.touched && dayOfTheMonth.errors?.required" class="text-danger" translate>
            Administration.Cleanup.Form.Errors.Day Of The Month Required
          </small>
        </div>
        <div class="p-field col-3">
          <p-floatlabel>
            <p-select
                name="dayOfTheWeek"
                #dayOfTheWeek="ngModel"
                inputId="dayOfTheWeek"
                appendTo="body"
                optionLabel="keyTranslated"
                optionValue="keyValue"
                [options]="daysOfTheWeekTranslated"
                [(ngModel)]="genericCleanupView.dayOfTheWeek"
                [showClear]="true"
                [disabled]="genericCleanupView.dayOfTheMonth"
                [required]="!genericCleanupView?.dayOfTheMonth"
            />
            <label htmlFor="dayOfTheWeek" translate> Administration.Cleanup.Form.Select A Day Of The Week </label>
          </p-floatlabel>
          <small *ngIf="dayOfTheWeek.touched && dayOfTheWeek.errors?.required" class="text-danger" translate>
            Administration.Cleanup.Form.Errors.Day Of The Week Required
          </small>
        </div>
        <div class="p-field col">
          <p-floatlabel>
            <p-datePicker
                #timeExecution="ngModel"
                name="timeExecution"
                hourFormat="24"
                [defaultDate]="startHourDefault"
                [(ngModel)]="genericCleanupView.timeExecution"
                [timeOnly]="true"
                [inline]="false"
                required>
            </p-datePicker>
            <label htmlFor="timeExecution" translate> Administration.Cleanup.Form.Time Execution </label>
            <small *ngIf="timeExecution.touched && timeExecution.errors?.required" class="text-danger" translate>
              Administration.Cleanup.Form.Errors.Time Required
            </small>
          </p-floatlabel>
        </div>
      </div>
    </form>
  </p-card>
</div>
